var $videoAbertura, $videoOverlay, $videoBtPlay;
var BARL;

$(document).ready(function () {
  if (TELA_MOBILE)
    replaceResponsiveImages(".bloco-img-zoom", "img_bg", "-mobile", true);

  $videoAbertura = $("#video-abertura-src");
  $videoOverlay = $("#overlay-video");
  $videoBtPlay = ".video-abertura--btplay";

  BARL = 60;

  $videoOverlay.mouseover(function () {
    animeOpacityPlay(1);
  });

  $videoOverlay.mouseout(function () {
    animeOpacityPlay(0.5);
  });

  $videoOverlay.click(function () {
    $(this).css("z-index", "0");
    $(this).css("opacity", "0");
    $videoAbertura[0].play();
  });

  $videoAbertura.bind("ended", function () {
    $videoOverlay.css("z-index", "50");
    $(".main--header-fixo").css("z-index", "150");
    $(".main--menu-lateral").css("z-index", "200!important");
    $videoOverlay.css("opacity", "1");
    $videoAbertura[0].webkitExitFullscreen();
  });
});

function animeOpacityPlay(val) {
  anime({
    targets: $videoBtPlay,
    opacity: val,
    duration: 500,
  });
}
